import styles from "./Home.module.css";
import Text from "../../components/Text/Text.jsx";
import Hero from "../../components/Hero/Hero.jsx";
import Karussell from "../../components/Karussell/Karussell.jsx";
import Spacer from "../../components/Spacer/Spacer.jsx";
import Angebote from "../../components/Angebote/Angebote.jsx";
import Galerie from "../../components/Galerie/Galerie.jsx";
import Impression from "../../components/Impressionen/Impression.jsx";

function Home() {
  return (
    <div className={styles.homeContainer}>
      <Hero />
      <Spacer space={"70px"} />
      <Text
        title="Über uns"
        body={
          "Foodosia steht für Catering mit Charakter – frisch, kreativ und persönlich. Wir glauben daran, dass gutes Essen mehr ist als nur ein Menü. Es ist ein Erlebnis, das Menschen verbindet, Erinnerungen schafft und Events zu etwas Besonderem macht."
        }
      />
      <Text
        body="Ob inspirierendes Business-Event mit Lunch (bereits ab 20 Personen) oder eure kommende Firmenfeier mit mehreren hundert Teilnehmern, ob gemütliche Feier im kleinen Kreis oder deine Traumhochzeit – wir gestalten kulinarische Erlebnisse, die genau zu euch passen. Dabei legen wir größten Wert auf Qualität, Regionalität und eine individuelle Betreuung von Anfang bis Ende."
      />
      <Text
        body="Unser Team bringt nicht nur Erfahrung aus Gastronomie und
              Eventplanung mit, sondern auch Leidenschaft fürs Detail und echtes
              Gespür für Geschmack. Jeder Auftrag ist für uns einzigartig – und
              genau so behandeln wir ihn auch."
      />
      <Spacer space={"80px"} />
      <Karussell />
      <div id="card-menu"></div> {/* Für die Ankerlinks */}
      <Spacer space={"70px"} />
      <Text
        title="Unsere Angebote"
        body="Ob herzhaftes Streetfood, exotische Genüsse oder moderne Klassiker – unsere Catering-Menüs bringen die Geschmäcker der Welt auf euren Tisch. Jedes Angebot ist mit viel Liebe zum Detail zusammengestellt und lässt sich individuell anpassen."
      />
      <Spacer space={"70px"} />
      <Angebote />
      <Spacer space={"85px"} />
      <Galerie />
      <div id="card-impression"></div> {/* Für die Ankerlinks */}
      <Spacer space={"70px"} />
      <Text
        title="Echte Stimmen, echte Erlebnisse."
        body="Unsere Gäste stehen im Mittelpunkt – und ihre Begeisterung spricht für sich. Hier teilen sie ihre Eindrücke von unseren kulinarischen Erlebnissen."
      />
      <Spacer space={"70px"} />
      <Impression />
      <Spacer space={"80px"} />
    </div>
  );
}

export default Home;
